module.exports = __webpack_public_path__ + "static/media/download (3).02ad8c54.svg";